(() => {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionEl = this.closest('[data-recs-section]');
      this.loadRecommendations();
    }

    loadRecommendations() {
      fetch(`${this.dataset.url}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.includes('<!--@product-card/split-->')) {
            this.innerHTML = recommendations.innerHTML;

            requestAnimationFrame(() => {
              window.inView();
              window.loadSwiper();

              requestAnimationFrame(() => {
                this.sectionEl?.classList.remove('visibility');
              });
            });
          } else {
            this.sectionEl?.classList.add('hide');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
